module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home-section-1"
    }
  }, [_c('div', {
    staticClass: "skew-grad-blue"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-after-skew"
  }, [_c('nav', {
    staticClass: "page-container no-flex"
  }, [_c('div', {
    attrs: {
      "id": "logo"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "menu-btn",
    attrs: {
      "type": "checkbox",
      "id": "menu-btn"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "menu-icon",
    attrs: {
      "for": "menu-btn"
    }
  }, [_c('span', {
    staticClass: "navicon"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    staticClass: "active",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("Login")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/register"
    }
  }, [_vm._v("Register")])])])]), _vm._v(" "), _c('section', {
    staticClass: "page-container"
  }, [_c('article', {
    staticClass: "half-page"
  }, [_c('h1', {
    staticClass: "headline"
  }, [_vm._v("Integrated and Simple Membership Process, Everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "brief-desc"
  }, [_vm._v("Sinarmas Land Membership provides an easy-to join any membership product. Integrated and easy payment process.")])]), _vm._v(" "), _c('aside', {
    staticClass: "half-page filler-image"
  }, [_c('span', {
    staticClass: "img-container"
  }, [_c('div', {
    staticClass: "c-hex blue",
    staticStyle: {
      "width": "86%",
      "left": "5%",
      "margin-top": "13%"
    }
  }, [_c('div', {
    staticClass: "c-hex-2"
  }, [_c('div', {
    staticClass: "r-hex",
    staticStyle: {
      "border-radius": "2.5%"
    }
  }, [_c('div', {
    staticClass: "r-hex-inner"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "c-hex peach",
    staticStyle: {
      "width": "18%",
      "left": "76%",
      "margin-top": "42%"
    }
  }, [_c('div', {
    staticClass: "c-hex-2"
  }, [_c('div', {
    staticClass: "r-hex"
  }, [_c('div', {
    staticClass: "r-hex-inner"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "c-hex green-2",
    staticStyle: {
      "width": "11%",
      "left": "89%",
      "margin-top": "33%"
    }
  }, [_c('div', {
    staticClass: "c-hex-2"
  }, [_c('div', {
    staticClass: "r-hex"
  }, [_c('div', {
    staticClass: "r-hex-inner"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "c-hex orange-4",
    staticStyle: {
      "width": "30%",
      "right": "72%",
      "margin-top": "60%"
    }
  }, [_c('div', {
    staticClass: "c-hex-2"
  }, [_c('div', {
    staticClass: "r-hex"
  }, [_c('div', {
    staticClass: "r-hex-inner"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "c-hex purple-2",
    staticStyle: {
      "width": "12%",
      "right": "62%",
      "margin-top": "80%"
    }
  }, [_c('div', {
    staticClass: "c-hex-2"
  }, [_c('div', {
    staticClass: "r-hex"
  }, [_c('div', {
    staticClass: "r-hex-inner"
  })])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c048314"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 724
// module chunks = 1